module.exports = __webpack_public_path__ + "img/permanent_refrigeration.6cba99e7.png";